export default __webpack_public_path__ + "static/3-a333deeb2e41ca2df5d42ff2924f01f8.png";